export const API_BASE_URL =
  "https://ahdnf7a6g9.execute-api.us-east-2.amazonaws.com/auth/";
export const STRIPE_API_KEY =
  process.env.NODE_ENV === "production"
    ? "pk_live_51H47ioL3l7aU5iEtkQnCV8UNNhT2Fhdexpiyr092fF3sDRr1by3dVnZCnlqPwbc1tbhvlJ6mlybdQCaZj0AdOFQZ007fuBQ5BJ"
    : "pk_test_51H47ioL3l7aU5iEt1FG5JZj4dpNhpAdzwTAbRZhodMwmpiACvTkkjMw8L7ZbqPvT3Ts9RF6iGgdVbo4nu0VPBjUs00iUMln9Jv";
export const STRIPE_SESSION_URL = `https://${
  process.env.NODE_ENV === "production"
    ? "spreaddevserver-prod"
    : "spreaddevserver"
}.herokuapp.com/create-checkout-session`;
export const StripeSessionUrl = "https://cors-anywhere.herokuapp.com/";
export const publickey =
  "pk_live_51H47ioL3l7aU5iEtkQnCV8UNNhT2Fhdexpiyr092fF3sDRr1by3dVnZCnlqPwbc1tbhvlJ6mlybdQCaZj0AdOFQZ007fuBQ5BJ";
// "pk_test_51H47ioL3l7aU5iEt1FG5JZj4dpNhpAdzwTAbRZhodMwmpiACvTkkjMw8L7ZbqPvT3Ts9RF6iGgdVbo4nu0VPBjUs00iUMln9Jv";
